export default __webpack_public_path__ + "static/media/postItBooked.4e4f528f.png";